import React from "react";
import { Helmet } from "react-helmet";
import domain from 'src/config/domain';

const Head = ({ ...props }) => {
  const domainConfig = domain();

  return (
    <Helmet>
      <link rel="icon" href={`/${domainConfig.isAcquirerFlow ? 'acqfavicon.ico' : 'favicon.ico'}`} />
      <title>{props.title ? props.title + " | " : null} {domainConfig.name}</title>
    </Helmet>
  );
};
export default Head;
